import './Webshop.scss'

import {wrap} from '@codeurs/front'
import React from 'react'
import {MainUrlTypes, PageData} from '../../../types'
import {getUrlByKey} from '../../../util/nav'
import {style} from '../../../util/style'
import {Blocks, BlockType} from '../../blocks/Blocks'
import {Hero, HeroType} from '../../layout/Hero'
import {Layout} from '../../layout/Layout'
import {ProductsFilter} from '../layout/product/ProductsFilter'

const styles = style('webshop')

type WebshopChannelData = {
	main_pages?: Array<MainUrlTypes>
	hero: HeroType
	blocks?: Array<BlockType>
}

export const Webshop: React.FC<PageData & WebshopChannelData> = wrap(Layout)(
	({...props}) => {
		const {
			main_pages: nav,
			title,
			hero,
			products,
			products_overview_title,
			product_groups: groups,
			product_filters: filters,
			downloads,
			downloads_overview_title,
			blocks
		} = props
		const productsLoadmoreLink = getUrlByKey(nav, 'products')?.url
		const downloadsLoadmoreLink = getUrlByKey(nav, 'downloads')?.url
		return (
			<div className={styles()}>
				<Hero {...hero} title={(hero && hero.title) || title} mod="home" />
				<ProductsFilter
					groups={groups}
					filters={filters}
					products={products}
					downloads={downloads}
					maxItems={6}
					productsOverviewTitle={products_overview_title}
					productsLoadmoreLink={productsLoadmoreLink}
					downloadsOverviewTitle={downloads_overview_title}
					downloadsLoadmoreLink={downloadsLoadmoreLink}
				/>
				<Blocks blocks={blocks} container={true} className={styles('blocks')} />
			</div>
		)
	}
)
